module.exports = __webpack_public_path__ + "img/aParty_110923_D.458a212c.jpg";